export const HOST = 'https://www.ecaidata.com';
// export const HOST = 'http://192.168.10.103';



// WEBPACK FOOTER //
// ./src/config.js